/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useEffect, useState } from 'react';
import G17Client from '../../../services/G17Client';
import Loader from '../../loader';
import { RequestToJoinForm } from '../partials/RequestToJoinForm';
import { CompanyNotAllowed } from '../partials/CompanyNotAllowed';
import { BaseStepCompProps, IssuerListItem } from '../types';
import { SectorInfo } from './SectorInfo';

export interface IssuerCompanyOnboardOrNotProps extends Pick<BaseStepCompProps,
  'updateForm' | 'formData' | 'stepperStateData' | 'appConfig' | 'handleNext' | 'handlePrevious'> {
}

export const IssuerCompanyOnboardOrNot = (props: IssuerCompanyOnboardOrNotProps) => {
  const { formData, stepperStateData } = props;

  const [isLoading, setLoading] = useState(false);
  const [issuer, setIssuer] = useState<IssuerListItem | undefined>();

  useEffect(() => {
    const referralCode = formData.referralCode;
    const issuerId = stepperStateData.issuerId;

    if (!referralCode || !issuerId) {
      return;
    }
    setLoading(true);
    G17Client.getIssuerByReferralCode(referralCode, issuerId)
      .then(setIssuer)
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [formData.referralCode, stepperStateData.issuerId]);

  if (isLoading) {
    return <Loader />;
  }

  if (issuer || stepperStateData.customCompanyEnabled) {
    if (issuer?.initiativeId) {
      const initiative = { _id: issuer.initiativeId, name: issuer.name };
      return <RequestToJoinForm {...props} initiatives={[initiative]} />;
    }
    return <SectorInfo {...props} />;
  }

  return <CompanyNotAllowed
    {...props}
    description={'We\'re sorry but SGX ESGenome is just for Singapore Listcos. '+
    'Unfortunately, we don\'t recognise your company name as a Singapore Listco.'}
  />;
}
